import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { hotSearch } from "@/mocks/topics";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "现场直击", to: "/live" },
  { label: "瓜田情报", to: "/live?tab=intel" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (to: string) => {
    const [path, query] = to.split("?");
    if (path === "/") return location.pathname === "/";
    if (query && location.search.includes(query)) return location.pathname === path;
    if (location.search) return false;
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-300/70 bg-background-50/95 backdrop-blur">
      <div className="hidden border-b border-background-200/70 bg-background-100 lg:block">
        <div className="mx-auto flex h-10 max-w-[1240px] items-center gap-4 px-6 text-xs text-foreground-600">
          <span className="flex items-center gap-1.5 font-medium text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            实时追踪中
          </span>
          <span className="h-3 w-px bg-background-300" />
          <span className="shrink-0 text-foreground-500">热搜速报</span>
          <div className="relative flex-1 overflow-hidden">
            <div className="klg-marquee-track flex w-max gap-6 whitespace-nowrap">
              {[...hotSearch, ...hotSearch].map((word, index) => (
                <span key={`${word}-${index}`} className="text-foreground-700">
                  {word}
                </span>
              ))}
            </div>
          </div>
          <span className="shrink-0 text-foreground-500">吃瓜第一线 · 瓜田情报</span>
        </div>
      </div>

      <div className="mx-auto flex h-16 max-w-[1240px] items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-wide text-foreground-950">
              看料大瓜
            </span>
            <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">
              KANLIAO LIVE
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className={`cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/live"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-live-line" />
            现场直击
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((value) => !value)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-2">
            {navLinks.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}